import { render } from "./measureMainCatNavItemComponent.vue?vue&type=template&id=73052b23"
import script from "./measureMainCatNavItemComponent.vue?vue&type=script&lang=js"
export * from "./measureMainCatNavItemComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__